<template>
  <Modal ref="modal" title="Presenças" @cancel="close">
    <div class="modal-container">
      <div class="loading" v-if="loading">
        <LoadingSpinner />
      </div>

      <Table v-else :headers="['Aluno', 'CPF', 'Entrada', 'Saída']">
        <tr v-if="!presencas.length">
          <td colspan="4">
            <div class="force-center">
              Sem presenças
            </div>
          </td>
        </tr>
        <tr v-else v-for="(presenca, index) in presencas" :key="index">
          <td>{{ presenca.nome }}</td>
          <td>{{ utils.formatarCPF(presenca.cpf) }}</td>
          <td>
            <span v-if="presenca.presenca > 0">Confirmada</span>
            <span v-else-if="presenca.presenca == 0">Sem presença</span>
          </td>
          <td>
            <span v-if="presenca.presenca == 2">Confirmada</span>
            <span v-else-if="presenca.presenca < 2">Sem presença</span>
          </td>
        </tr>
      </Table>
    </div>
  </Modal>
</template>

<script>
import utils from '../../services/utils'
import Modal from 'core/Modal'
import LoadingSpinner from 'core/LoadingSpinner'
import Table from 'core/Table'

export default {
  name: 'PresencasModal',
  components: {
    Modal,
    LoadingSpinner,
    Table,
  },
  data() {
    return {
      utils: utils,
      turma: null,
      presencas: [],
      loading: true,
    }
  },
  methods: {
    async open(turma) {
      this.turma = turma

      await this.detalhes()
    },
    async detalhes() {
      this.$refs.modal.open()

      await this.getPresencas()

      this.loading = false
    },
    async getPresencas() {
      await this.$http.get(`${process.env.VUE_APP_URL_API}/aulas/teoricas/presenca/${this.turma.id_turma_teorica}`)
        .then(res => {
          this.presencas = res.body
        })
        .catch(err => {
          this.$toasted.show('Erro ao buscar presenças!', {
            position: 'top-right',
          })

          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    close() {
      this.turma = null
      this.presencas = []
      this.loading = true
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  width: 60vw;

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .force-center {
    display: flex;
    justify-content: center;
  }
}
</style>
